/**
 * =================
 * COOKIES
 * Advice
 * =================
 */

import { Cookie } from "./cookie";


export class CookiesAdvice {
	constructor(name, expiryDays) {
		this.name = name;
		this.expiryDays = expiryDays;

		this.init();
	}

	init() {
		let pop = $('#cookies-advice');

		if (!pop.length) {
			return;
		}

		const name = this.name || 'cookiesAdvices';

		// datas
		const persist = pop.data('persist');
		const message = pop.data('message');
		const linkUrl = pop.data('linkUrl');

		const cookie = new Cookie();

		if (!cookie.get(name) || persist) {
			pop
				.show()
				.append(message.replace(/%(.*?)%/g, '<a class="lnk" href="'+ linkUrl +'" target="_blank" rel="blank">$1</a>'))
				.on('click', '.cookies-advice__close-button', (e) => {
					e.preventDefault();
					cookie.set(name, 1, this.expiryDays || 365);
					pop = pop.remove() && null;
				});

			return;
		}

		pop = pop.remove() && null;
	}

	reset(name) {
		Cookie.remove(this.name || name || 'cookiesAdvice');
	}
}
